import { ContainerSize } from "@topyourthree/ui/container";
import * as i0 from "@angular/core";
import * as i1 from "../app/navigation/seo-navbar/seo-navbar.component";
export class CompatSeoNavbarComponent {
    constructor() {
        this.containerSize = ContainerSize.DESKTOP_LARGE;
    }
    ngOnInit() {
        const w = window;
        if (w.webappCompat && w.webappCompat["seo-navbar"]) {
            this.containerSize =
                w.webappCompat["seo-navbar"].containerSize ??
                    ContainerSize.DESKTOP_LARGE;
            this.isCrawler = !!w.webappCompat["seo-navbar"].isCrawler;
        }
    }
}
CompatSeoNavbarComponent.ɵfac = function CompatSeoNavbarComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatSeoNavbarComponent)(); };
CompatSeoNavbarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CompatSeoNavbarComponent, selectors: [["webapp-compat-seo-navbar"]], decls: 1, vars: 2, consts: [[3, "containerSize", "isCrawler"]], template: function CompatSeoNavbarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "app-seo-navbar", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("containerSize", ctx.containerSize)("isCrawler", ctx.isCrawler);
    } }, dependencies: [i1.SeoNavbarComponent], encapsulation: 2, changeDetection: 0 });
